<template>
  <div class="page login-page-modern">
    <!-- 动态渐变背景 -->
    <div class="ambient-background"></div>

    <!-- 居中主容器 -->
    <div class="login-container">
      <!-- 左侧欢迎展示区 -->
      <div class="login-presentation">
        <div class="brand-logo-area">
          <img src="../assets/img/bg_logo.png" class="brand-logo" alt="Logo" />
          <span class="brand-text">数刷刷智慧数学平台</span>
        </div>
        <div class="presentation-content">
          <h1 class="welcome-title">欢迎登录</h1>
          <p class="welcome-subtitle">
            探索数学之美，解构逻辑奥秘，开启您的数理智慧之旅。
          </p>
        </div>
        <!-- 扫码登录入口（作为装饰按钮放在左侧下方或上方） -->
        <div class="scan-entry" @click="goState(2)">
          <div class="scan-text">扫码快捷登录</div>
          <div class="scan-icon-wrap">
            <img
              src="../assets/img/icon_erweima.png"
              class="scan-icon"
              alt="扫码"
            />
          </div>
        </div>
      </div>

      <!-- 右侧表单操作区 -->
      <div class="login-form-area">
        <!-- 顶部标签栏 -->
        <div class="login-tabs">
          <div
            class="tab-item"
            :class="{ active: state == '1' }"
            @click="goState(1)"
          >
            学号登录
          </div>
          <div
            class="tab-item"
            :class="{ active: state == '3' }"
            @click="goState(3)"
          >
            手机号登录
          </div>
        </div>

        <div class="form-wrapper">
          <!-- 学号登录 -->
          <transition name="fade-slide" mode="out-in">
            <div class="login-panel" v-if="state == 1" key="studentCode">
              <el-form
                :model="userInfo"
                status-icon
                :rules="rules"
                ref="userInfo"
                label-width="0"
              >
                <el-form-item prop="collegeName" class="modern-form-item">
                  <el-cascader
                    v-model="userInfo.collegeName"
                    :options="provincesList"
                    :props="props"
                    @change="handleChange"
                    placeholder="请选择学校"
                    class="modern-input"
                    clearable
                  >
                  </el-cascader>
                </el-form-item>

                <el-form-item prop="studentNo" class="modern-form-item">
                  <el-input
                    v-model="userInfo.studentNo"
                    class="modern-input"
                    placeholder="请输入学生账号"
                    prefix-icon="el-icon-user"
                    clearable
                  ></el-input>
                </el-form-item>

                <el-form-item prop="password" class="modern-form-item">
                  <el-input
                    type="password"
                    v-model="userInfo.password"
                    class="modern-input"
                    placeholder="请输入密码"
                    prefix-icon="el-icon-lock"
                    clearable
                    @keyup.enter.native="login()"
                    @change="input()"
                  ></el-input>
                </el-form-item>

                <div class="actions-row">
                  <el-button
                    type="text"
                    class="forgot-pwd-btn"
                    @click="beginReset()"
                    >忘记密码？</el-button
                  >
                </div>

                <el-button
                  @click="login()"
                  type="primary"
                  class="modern-submit-btn"
                  :loading="loading"
                >
                  <span>登 录</span>
                  <i class="el-icon-right"></i>
                </el-button>
              </el-form>
            </div>

            <!-- 手机号登录 -->
            <div class="login-panel" v-if="state == 3" key="phoneCode">
              <el-form
                :model="userInfo"
                status-icon
                :rules="rules"
                ref="userInfo"
                label-width="0"
              >
                <el-form-item prop="phone" class="modern-form-item">
                  <el-input
                    v-model="userInfo.phone"
                    class="modern-input"
                    placeholder="请输入手机号"
                    prefix-icon="el-icon-mobile-phone"
                    clearable
                  ></el-input>
                </el-form-item>

                <!-- 手机号 - 密码登录 -->
                <el-form-item
                  prop="password"
                  v-if="type == 1"
                  class="modern-form-item"
                >
                  <el-input
                    type="password"
                    v-model="userInfo.password"
                    class="modern-input"
                    placeholder="请输入密码"
                    prefix-icon="el-icon-lock"
                    clearable
                    @keyup.enter.native="onphoneLogin()"
                  ></el-input>
                </el-form-item>

                <!-- 手机号 - 验证码登录 -->
                <el-form-item
                  prop="code"
                  v-if="type == 2"
                  class="modern-form-item verify-code-item"
                >
                  <el-input
                    v-model="userInfo.code"
                    maxlength="6"
                    placeholder="请输入验证码"
                    class="modern-input"
                    prefix-icon="el-icon-message"
                  >
                  </el-input>
                  <el-button
                    @click="btnClcik()"
                    :disabled="isDisable"
                    class="get-code-btn"
                    type="primary"
                    plain
                  >
                    {{ tips }}
                  </el-button>
                </el-form-item>

                <div class="actions-row">
                  <el-button
                    type="text"
                    class="switch-login-type"
                    @click="checkType(type == 1 ? 2 : 1)"
                  >
                    {{ type == 1 ? "验证码登录" : "密码登录" }}
                  </el-button>
                  <el-button
                    type="text"
                    class="forgot-pwd-btn"
                    @click="beginReset()"
                    >忘记密码？</el-button
                  >
                </div>

                <el-button
                  @click="onphoneLogin()"
                  type="primary"
                  class="modern-submit-btn"
                  :loading="loading"
                >
                  <span>登 录</span>
                  <i class="el-icon-right"></i>
                </el-button>
              </el-form>
            </div>

            <!-- 扫码登录 -->
            <div
              class="login-panel qr-code-panel"
              v-if="state == '2'"
              key="qrCode"
            >
              <h2 class="qr-title">扫码安全登录</h2>
              <div class="qr-code-box">
                <vue-qr
                  v-if="loginTimer < 60"
                  :text="downloadData.url"
                  :logoSrc="downloadData.imageUrl"
                  :logoScale="0.2"
                  colorDark="#2c3e50"
                  colorLight="#ffffff"
                  :size="180"
                ></vue-qr>
                <div v-else class="qr-expired">
                  <div class="expired-icon">
                    <i class="el-icon-warning-outline"></i>
                  </div>
                  <h5 class="expired-text">二维码已失效</h5>
                  <el-button
                    type="primary"
                    class="refresh-qr-btn"
                    @click="get_uid"
                    round
                    >刷新二维码</el-button
                  >
                </div>
              </div>
              <p class="qr-tip">请使用APP扫描上方二维码登录</p>
            </div>
          </transition>
        </div>

        <!-- 底部协议 -->
        <div class="login-footer-policy">
          <span>点击登录即表示同意</span>
          <el-link type="primary" :underline="false" class="policy-link"
            >《隐私政策》</el-link
          >
          <span>和</span>
          <el-link type="primary" :underline="false" class="policy-link"
            >《服务条款》</el-link
          >
        </div>
      </div>
    </div>

    <!-- 页面底部版权 -->
    <div class="modern-page-footer">
      <div class="footer-item">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
          <span>©2021 滇ICP备2021007044号</span>
        </a>
      </div>
      <div class="footer-item flex-center">
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=53019102000371"
          target="_blank"
        >
          <img
            src="../assets/qq/national-emblem.png"
            class="national-emblem"
            alt="公网安备"
          />
          <span>滇公网安备 53019102000371号</span>
        </a>
      </div>
    </div>

    <!-- 考前必读 -->
    <el-dialog
      title="考前必读"
      :visible.sync="readDialogShow"
      width="50%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <div class="tip">数刷刷考试平台考前必读</div>
        <div class="tip">1、请不要用IE浏览器打开本考试平台。</div>
        <div class="tip">
          2、请各位考生在考试前，提前进行个人信息注册，及密码设置。
        </div>
        <div class="tip">
          3、进入考试平台后，到时间方可进行考试，点击开始考试提取试卷。
        </div>
        <div class="tip">
          4、在考试平台点选完客观题后，请在平台右侧题型及题目栏点选相应主观题，并在答题卡上完成主观题后方可点击交卷。
        </div>
        <div class="tip">
          5、完成客观题选择并完成答题卡主观题答题后，点击交卷并将答题卡交予监考老师后方可离开。
        </div>
        <div class="tip">
          6、答题过程未点击交卷，中途关闭浏览器，浏览器会再次确认，关闭浏览器不等于交卷
        </div>
        <div class="tip">7、如遇到题目无法显示，请点击浏览器刷新页面即可。</div>
        <div class="tip">
          8、如遇交卷无法提交，请耐心等待，并重复提交，直至跳转至考试列表。
        </div>
        <div class="tip">
          9、如遇断电等硬件故障需要重启计算机，请重启后重新向监考老师索取试卷提取码提取试卷。
        </div>
        <div class="tip" style="color: red; font-weight: bold">
          10、请注意答题过程中，鼠标不要离开当前页面，如果离开当前页面会被记录，达到十次将会被强制提交试卷。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :type="readTimeLeft !== 0 ? 'info' : 'primary'"
          :disabled="readTimeLeft !== 0"
          @click="readDialogConfirm"
          >{{
            readTimeLeft === 0 ? "确认阅读" : "确认阅读" + readTimeLeft + "s"
          }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 注册信息弹出层 -->
    <el-dialog
      title="注册账号"
      :visible.sync="registerDialogShow"
      width="50%"
      :close-on-click-modal="false"
      :show-close="false"
      center
      class="registerDialog"
    >
      <el-form
        :model="StudentInfo"
        :rules="StudentInfoRules"
        ref="StudentInfoForm"
        label-width="100px"
        class="infoForm"
      >
        <el-form-item label="姓名" prop="name">
          <i class="el-icon-user" slot="label">{{ str }}姓名</i>
          <el-input v-model="StudentInfo.name" placeholder="请输入姓名">
          </el-input>
        </el-form-item>
        <el-form-item label="学号" prop="studentNo">
          <i class="el-icon-school" slot="label">{{ str }}学号</i>
          <el-input
            v-model="StudentInfo.studentNo"
            maxlength="11"
            placeholder="请输入学号"
          ></el-input>
        </el-form-item>
        <el-form-item label="学校" prop="lebel">
          <i class="el-icon-school" slot="label">{{ str }}学校</i>
          <el-cascader
            v-model="StudentInfo.lebel"
            :options="provincesList"
            :props="props"
            :label="StudentInfo.label"
            @change="handleregisterChange"
            placeholder="请选择学校"
            class="cascader"
            ref="myCascader"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="专业" prop="profession">
          <i class="el-icon-school" slot="label">{{ str }}专业</i>
          <el-select
            v-model="StudentInfo.profession"
            placeholder="请选择专业"
            class="cascader"
          >
            <el-option
              v-for="item in profession"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
              {{ item.name }}
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="年级" prop="options.label">
          <i class="el-icon-school" slot="label">{{ str }}年级</i>
          <el-select
            v-model="StudentInfo.options.label"
            placeholder="请选择"
            class="cascader"
          >
            <el-option
              v-for="item in StudentInfo.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-select v-model="value" filterable placeholder="请选择">
    <el-option
      v-for="item in checkYear"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select> -->

        <el-form-item label="手机号" prop="phone">
          <i class="el-icon-mobile" slot="label">手机号</i>
          <el-input
            v-model="StudentInfo.phone"
            maxlength="11"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-button @click="btnClcik()" :disabled="isDisable">
            {{ tips }}</el-button
          >
          <i class="el-icon-message" slot="label">验证码</i>
          <el-input
            v-model="StudentInfo.code"
            maxlength="6"
            placeholder="请输入验证码"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <i class="el-icon-lock" slot="label">{{ str }}密码</i>
          <el-input
            v-model="StudentInfo.password"
            type="password"
            maxlength="6"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="passwords">
          <el-input
            v-model="StudentInfo.passwords"
            type="password"
            maxlength="6"
            placeholder="请确认密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancal()">取 消</el-button>
        <el-button type="warning" @click="openRegisterInfo">注 册</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="找回密码"
      :visible.sync="dialogReset"
      :model="false"
      width="30%"
      :append-to-body="true"
      :before-close="onforegetDialogClose"
    >
      <el-form
        :model="userInfo"
        status-icon
        :rules="rules"
        ref="userInfo"
        class="demo-form-inline"
      >
        <el-form-item
          label="选择学校"
          class="formRow"
          prop="collegeName"
          v-show="!hasverify"
        >
          <el-cascader
            v-model="userInfo.collegeName"
            :options="provincesList"
            :props="props"
            @change="handleChange"
            placeholder="请选择学校"
            class="formInfoInput cascader"
            clearable
          >
          </el-cascader>
        </el-form-item>
        <el-form-item
          label="学号"
          class="formRow"
          prop="studentNo"
          v-show="!hasverify"
        >
          <el-input
            v-model="userInfo.studentNo"
            class="formInfoInput"
            placeholder="请输入学生账号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email" class="formRow">
          <el-input
            v-model="userInfo.email"
            type="text"
            class="formInfoInput"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="验证码"
          prop="code"
          v-show="hasverify"
          style="position: relative"
          class="formRow"
        >
          <i class="el-icon-message" slot="label">验证码</i>
          <el-input
            v-model="userInfo.code"
            maxlength="6"
            placeholder="请输入验证码"
            class="formInfoInput"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          prop="password"
          class="formRow"
          v-show="hasverify"
        >
          <el-input
            type="password"
            v-model="userInfo.password"
            class="formInfoInput"
            placeholder="请输入密码"
            clearable
            @change="input()"
          ></el-input>
        </el-form-item>
        <div
          style="position: relative;right:30px;display:flex;justify-content:flex-end;"
        >
          <el-button @click="btnYanzheng()" autofocus :disabled="hasverify"
            >验证</el-button
          >
          <el-button
            @click="getVerfiCodeClick()"
            :disabled="!hasverify"
            class="codeBtn"
          >
            {{ tips }}</el-button
          >

          <el-button
            type="primary"
            :plain="true"
            :disabled="!hasverify"
            @click="resetPassword()"
            >修改密码</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script src="../../util/session/getIp.js"></script>
<script>
import {
  login,
  register,
  sendCode,
  phoneLogin,
  sendEmailCode,
  getCollegeDetailInfo,
  getMajorByCollegeId
} from "@/api/login";
import {
  getScanQrCde,
  verifyStudentInfo,
  studentResetPassword
} from "@/api/student";
import {
  setToken,
  clearToken,
  setStudentID,
  setInfo,
  setUserInfo
} from "@/util/session";
import vueQr from "vue-qr";
import { Message } from "element-ui";
import { IsEmptyString } from "@/util/stringutl.js";
export default {
  name: "login",
  components: {
    vueQr
  },
  data() {
    return {
      type: 1,
      profession: [],
      str: "\u3000", //空格字符占据一个汉字的宽度
      dialogVisible: false,
      dialogReset: false,
      isDisable: false,
      tips: "获取验证码",
      verifyCode: "",
      hasverify: false,
      collegeid: -1,
      studentId: -1,
      checkYear: [
        {
          value: "",
          label: ""
        }
      ],
      StudentInfo: {
        options: [
          {
            value: "2024级",
            label: "2024级"
          },
          {
            value: "2023级",
            label: "2023级"
          },
          {
            value: "2022级",
            label: "2022级"
          },
          {
            value: "2021级",
            label: "2021级"
          },
          {
            value: "2020级",
            label: "2020级"
          },
          {
            value: "2029级",
            label: "2019级 "
          },
          {
            value: "2028级",
            label: "2018级"
          },
          {
            value: "2027级",
            label: "2017级"
          },
          {
            value: "2026级",
            label: "2016级"
          },
          {
            value: "2025级",
            label: "2015级"
          },
          {
            value: "2024级",
            label: "2014级"
          },
          {
            value: "2013级",
            label: "2013级"
          }
        ],
        value: "",
        labelValue: [],

        classId: 0,
        code: "",
        name: "",
        password: "",
        passwords: "",
        phone: "",
        studentNo: "",
        collegeid: -1,
        collegeName: [],
        professional: []
      },
      registerInfo: {},
      provincesList: [],
      props: {
        value: "id",
        label: "label",
        children: "children"
      },
      registerDialogShow: false,
      StudentInfoRules: {
        value: [
          {
            required: true,
            message: "请选择年级",
            trigger: "change"
          }
        ],
        profession: [
          {
            required: true,
            message: "请选择专业",
            trigger: "change"
          }
        ],
        school: [{ required: true, message: "请选择学校", trigger: "blur" }],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur"
          },
          {
            pattern: /^\d{6}$/,
            message: "验证码格式错误",
            trigger: "blur"
          }
        ],
        passwords: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请确认密码"));
              } else if (value !== this.StudentInfo.password) {
                callback(new Error("两次输入密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: "blur"
          },
          {
            pattern: /^1[3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号格式错误",
            trigger: "blur"
          }
        ],
        studentNo: [
          {
            required: true,
            message: "学号不能为空",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "邮箱不能为空",
            trigger: "blur"
          },
          {
            pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z]{2,6}$/,
            message: "邮箱格式错误",
            trigger: "change"
          }
        ],
        lebel: [
          {
            required: true,
            message: "请选择学校",
            trigger: "change",
            type: "array"
          }
        ]
      },

      userInfo: {
        studentNo: "",
        password: "",
        phone: "",
        collegeName: [],
        code: "",
        email: ""
        // 测试
        // account: 20201304780, //学生账号已经修改成必须是手机号码
        // password: 123456
      },
      loading: false,
      readTimeLeft: 5,
      readDialogShow: true,
      rules: {
        collegeName: [
          {
            required: true,
            message: "请选择学校",

            trigger: "change",
            type: "array"
          }
        ],
        account: [
          {
            required: true,
            message: "账号不能为空",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          }
        ]
      },
      state: 1,
      downloadData: {
        url: "",
        imageUrl: require("@/assets/img/bg_logo.png")
      },
      loginTimer: "",
      isFrist: "",
      timers: undefined
    };
  },
  mounted() {
    this.getYear();
    clearToken();
    this.readTimeLeftFunc();
    this.getProductType();
  },

  methods: {
    beginReset() {
      this.dialogReset = true;
    },
    getVerfiCodeClick() {
      sendEmailCode(this.userInfo.email)
        .then(resp => {
          this.verifyCode = resp.data;
        })
        .catch(err => {
          Message.error(`网络错误${err}`);
        });
    },
    btnYanzheng() {
      verifyStudentInfo({
        collegeId: this.collegeid,
        email: this.userInfo.email,
        userNo: this.userInfo.studentNo
      })
        .then(resp => {
          if (resp.success) {
            Message.success("信息验证成功");
            this.hasverify = true;
            this.studentId = resp.data;
          } else {
            Message.error(resp.message);
          }
        })
        .catch(err => {
          Message.error(err);
        });
    },
    //重置密码
    resetPassword() {
      // if (this.verifyCode === this.userInfo.code) {
      if (IsEmptyString(this.userInfo.password)) {
        Message.error("密码为空");
        return;
      }
      studentResetPassword(
        this.studentId,
        this.userInfo.password,
        this.userInfo.code
      )
        .then(res => {
          if (res.success) {
            Message.success(res.data);
            this.onforegetDialogClose();
          } else {
            Message.error(res.message);
          }
        })
        .catch(err => {
          Message.error(err);
        });
      // } else {
      //   Message.error("验证码不匹配");
      // }
    },
    onforegetDialogClose() {
      this.dialogReset = false;
      this.verifyCode = "";
      this.hasverify = false;
      this.userInfo.studentNo = "";
      this.userInfo.password = "";
      this.userInfo.phone = "";
      this.userInfo.code = "";
      this.userInfo.email = "";
      this.userInfo.collegeName = [];
      this.collegeid = -1;
      this.studentId = -1;
    },
    checkType(index) {
      if (index == 1) {
        this.type = 2;
      } else {
        this.type = 1;
      }
    },
    input() {
      console.log(this.userInfo.password);
      let replace = encodeURIComponent(this.userInfo.password);

      this.userInfo.password = replace;
    },
    //获取年份
    getYear() {
      let nowDate = new Date();
      var year = [];
      var years = [];
      year = nowDate.getFullYear();
      console.log(year);
      for (let i = 7; i > 1; i--) {
        year = year - 1;
        years.push(year);
      }

      console.log((this.checkYear = years));
      console.log(this.checkYear);
    },

    //获取学校
    handleChange(value) {
      if (value.length === 3) {
        let seldep = value[2];
        let ids = seldep.split("-");
        if (ids.length == 3) {
          this.collegeid = parseInt(ids[2]);
        }
      }
    },
    //注册页面获取专业
    handleregisterChange(value) {
      let labelValue = this.$refs.myCascader.getCheckedNodes()[0].pathLabels;
      this.StudentInfo.collegeName = labelValue[labelValue.length - 1];
      if (value.length === 3) {
        let seldep = value[2];
        let ids = seldep.split("-");
        if (ids.length == 3) {
          this.StudentInfo.collegeid = parseInt(ids[2]);
        }
        getMajorByCollegeId(this.StudentInfo).then(res => {
          this.profession = res.data;
          console.log(1);
        });
      }
    },

    //学校
    getProductType() {
      getCollegeDetailInfo().then(res => {
        this.provincesList = res.data;
        this.provincesList.forEach(province => {
          province.children.forEach(citydata => {
            citydata.children.forEach(collegedata => {
              collegedata.label = collegedata.name;
            });
          });
        });
        console.log(res.data);
      });
    },
    //注册信息确认
    openRegisterInfo() {
      this.$refs.StudentInfoForm.validate(async valid => {
        if (valid) {
          this.dialogVisible = true;
          this.registerInfo.phone = this.StudentInfo.phone;
          this.registerInfo.name = this.StudentInfo.name;
          this.registerInfo.studentNo = this.StudentInfo.studentNo;
          this.registerInfo.professional = this.StudentInfo.profession;
          this.registerInfo.password = this.StudentInfo.password;
          this.registerInfo.collegeName = this.StudentInfo.collegeName;
          this.registerInfo.className = this.StudentInfo.options.label;
          this.StudentInfo.className = this.registerInfo.className;
          this.StudentInfo.majorName = this.registerInfo.professional;
          console.log(this.registerInfo, this.StudentInfo);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //注册表单信息的提交
    submitFormData() {
      this.$refs.StudentInfoForm.validate(async valid => {
        if (valid) {
          const { success } = await register(this.StudentInfo);
          console.log(this.StudentInfo);
          if (success) {
            this.$message({
              message: "注册成功,请登录",
              type: "success"
            });
            this.dialogVisible = false;
            this.registerDialogShow = false;
            this.StudentInfo = this.$options.data().StudentInfo;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancal() {
      //取消,关闭弹出层,清除校验规则,重置表单数据
      this.registerDialogShow = false;
      this.$refs.StudentInfoForm.resetFields();
      this.StudentInfo = this.$options.data().StudentInfo;
    },
    async btnClcik() {
      if (this.type == 2) {
        console.log(1);
        if (this.userInfo.phone) {
          //手机号验证通过,才可以发起请求获取验证码
          let timeout = 60;
          let timer = setInterval(() => {
            timeout--;
            // console.log(timeout--);
            if (timeout < 0) {
              this.tips = this.$options.data().tips;
              clearInterval(timer);
              this.isDisable = false;
            } else {
              this.tips = `${"已发送" + "(" + timeout + "s)"}`;
              //有timer的时候,禁用按钮,避免重复激活定时器
              this.isDisable = true;
            }
            if (!this.registerDialogShow) {
              this.isDisable = false;
              this.tips = this.$options.data().tips;
              clearInterval(timer);
            }
          }, 1000);
          const { success } = await sendCode({
            phone: this.userInfo.phone,
            type: 1
          });
          if (success) {
            this.$message({
              message: "验证码发送成功",
              type: "success"
            });
          }
        } else {
          // 手机号如果为空,触发单独验证
          this.$refs.userInfo.validate("phone");
        }
      } else {
        if (this.StudentInfo.phone) {
          //手机号验证通过,才可以发起请求获取验证码
          let timeout = 60;
          let timer = setInterval(() => {
            timeout--;
            // console.log(timeout--);
            if (timeout < 0) {
              this.tips = this.$options.data().tips;
              clearInterval(timer);
              this.isDisable = false;
            } else {
              this.tips = `${"已发送" + "(" + timeout + "s)"}`;
              //有timer的时候,禁用按钮,避免重复激活定时器
              this.isDisable = true;
            }
            if (!this.registerDialogShow) {
              this.isDisable = false;
              this.tips = this.$options.data().tips;
              clearInterval(timer);
            }
          }, 1000);

          // 调用接口发送code
          const { success } = await sendCode({
            phone: this.StudentInfo.phone,
            type: 0
          });
          if (success) {
            this.$message({
              message: "验证码发送成功",
              type: "success"
            });
          }
        } else {
          // 手机号如果为空,触发单独验证
          this.$refs.StudentInfoForm.validate("phone");
        }
      }
    },
    goState(index) {
      if (index == 2) {
        this.state = 2;
        this.isFrist += 1;
        if (this.isFrist == 1) {
          this.get_uid();
        }
      } else if (index == 1) {
        this.state = 1;
        clearInterval(this.timers);
      } else {
        this.state = 3;
        clearInterval(this.timers);
      }
    },

    //通过uid随机生成二维码
    get_uid() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = "-";

      var uid = s.join("");
      this.downloadData.url = uid;
      var timer = 0;
      this.timers = setInterval(() => {
        // timer += 2;
        this.loginTimer = timer;
        getScanQrCde({
          uid: uid
        })
          .then(res => {
            console.log(res);
            var token = res.data;
            if (token) {
              setToken(token);
              this.$router.replace({ path: "/home" });
              clearInterval(this.timers);
              return;
            } else if (timer >= 60) {
              clearInterval(this.timers);
              return;
            }
          })
          .catch(err => {
            console.log(err);
          });
      }, 2000);

      return uid;
    },
    //扫码登录
    // creatQrCode() {
    //   var qrcode = new QRCode(this.$refs.qrCodeUrl, {
    //       text: 'xxxx',
    //       width: 100,
    //       height: 100,
    //       colorDark: '#000000',
    //       colorLight: '#ffffff',
    //       correctLevel: QRCode.CorrectLevel.H
    //   })
    // },

    // phoneLogin(){

    // },
    login() {
      this.$refs["userInfo"].validate(valid => {
        if (valid) {
          this.loading = true;
          this.userInfo.collegeid = this.collegeid;
          login(this.userInfo)
            .then(res => {
              console.log(res.code);
              if (res.code === 200) {
                let token = res.data.token;
                //token和id都保存本地
                setToken(token);
                setStudentID(res.data.studentId);
                setUserInfo(JSON.stringify(res.data));
                setInfo("1");
                // console.log("id", res.data.studentId);
                // studentDetail(res.data).then(res => {
                //   setStudentID(res.data.id);
                // });
                this.$router.replace({ path: "/home" });
                clearInterval(this.timers);
                // this.$message.success('登录成功')
                this.userInfo.phone = "";
                this.userInfo.code = "";
              } else {
                this.$message.error(res.message);
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },

    onphoneLogin() {
      this.$refs["userInfo"].validate(valid => {
        if (valid) {
          this.loading = true;
          phoneLogin(this.userInfo)
            .then(res => {
              if (res.code === 200) {
                let token = res.data.token;
                //token和id都保存本地
                setToken(token);
                setStudentID(res.data.studentId);
                setUserInfo(JSON.stringify(res.data));
                setInfo("1");
                this.$router.replace({ path: "/home" });
                clearInterval(this.timers);
              } else {
                this.$message.error(res.message);
              }

              //
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    //注册显示
    register() {
      this.registerDialogShow = true;
    },
    readTimeLeftFunc() {
      this.interval = setInterval(() => {
        if (this.readTimeLeft === 0) {
          clearInterval(this.interval);
          return;
        }
        this.readTimeLeft = this.readTimeLeft - 1;
      }, 1000);
    },
    readDialogConfirm() {
      if (this.readTimeLeft === 0) {
        this.readDialogShow = false;
      }
    }
  },
  //发送短信
  computed: {
    //获取年份
  }
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

::v-deep .registerDialog .el-dialog__header {
  background-color: #2563eb;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .registerDialog .el-form .el-form-item__label {
  text-align: left;
}

/* ===== 核心布局 & 动态背景 ===== */
.login-page-modern {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-color: #f0f4f8;
}

.ambient-background {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    #e0e7ff 0%,
    #dbeafe 25%,
    #bfdbfe 50%,
    #dbeafe 75%,
    #e0e7ff 100%
  );
  background-size: 400% 400%;
  animation: gradientBG 15s ease infinite;
  z-index: 0;
}

@keyframes gradientBG {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* ===== 居中容器 (左右分栏毛玻璃卡片) ===== */
.login-container {
  display: flex;
  width: 900px;
  height: 560px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.5) inset;
  z-index: 10;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 1024px) {
    width: 800px;
    height: 520px;
  }
  @media screen and (max-width: 768px) {
    width: 90%;
    flex-direction: column;
    height: auto;
    min-height: 600px;
  }
}

/* ===== 左侧品牌展示区 ===== */
.login-presentation {
  flex: 5;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    display: none; /* 移动端隐藏左侧以节省空间 */
  }

  &::before {
    content: "";
    position: absolute;
    top: -20%;
    right: -20%;
    width: 300px;
    height: 300px;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.15) 0%,
      transparent 70%
    );
    border-radius: 50%;
  }
}

.brand-logo-area {
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 1;

  .brand-logo {
    width: 32px;
    height: 32px;
    object-fit: contain;
    background-color: #ffffff;
    padding: 4px;
    border-radius: 6px;
  }

  .brand-text {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }
}

.presentation-content {
  z-index: 1;
  text-align: center;

  .welcome-title {
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 16px;
    line-height: 1.2;
  }
  .welcome-subtitle {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    max-width: 80%;
    margin: 0 auto;
  }
}

.scan-entry {
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: rgba(0, 0, 0, 0.2);
  padding: 10px 20px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  width: fit-content;

  &:hover {
    background: rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
  }

  .scan-text {
    font-size: 14px;
    font-weight: 500;
  }

  .scan-icon {
    width: 24px;
    height: 24px;
    filter: brightness(0) invert(1);
  }
}

/* ===== 右侧表单操作区 ===== */
.login-form-area {
  flex: 6;
  padding: 40px 50px;
  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-width: 768px) {
    padding: 30px;
  }
}

/* 顶部标签切换 */
.login-tabs {
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  border-bottom: 1px solid #e2e8f0;

  .tab-item {
    font-size: 18px;
    font-weight: 600;
    color: #64748b;
    padding-bottom: 12px;
    cursor: pointer;
    position: relative;
    transition: color 0.3s;

    &.active {
      color: #1e293b;
      &::after {
        content: "";
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 3px;
        background: #2563eb;
        border-radius: 3px 3px 0 0;
      }
    }
  }
}

/* 表单容器与动画 */
.form-wrapper {
  flex: 1;
  position: relative;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
.fade-slide-leave-active {
  position: absolute;
  width: 100%;
}

.login-panel {
  width: 100%;
}

/* ===== 现代表单控件定制 ===== */
.modern-form-item {
  margin-bottom: 24px;
}

::v-deep .modern-input {
  .el-input__inner {
    height: 52px;
    border-radius: 12px;
    background-color: #ffffff;
    border: 1px solid #cbd5e1;
    font-size: 15px;
    color: #1e293b;
    transition: all 0.3s ease;

    &:focus,
    &:hover {
      border-color: #3b82f6;
      box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
    }

    &::placeholder {
      color: #94a3b8;
    }
  }

  &.el-input--prefix .el-input__inner {
    padding-left: 45px;
  }

  .el-input__prefix {
    left: 15px;
    color: #94a3b8;
    i {
      line-height: 52px;
      font-size: 18px;
    }
  }
}

/* 验证码特殊布局 */
.verify-code-item {
  ::v-deep .el-form-item__content {
    display: flex;
    gap: 12px;
  }

  .modern-input {
    flex: 1;
  }

  .get-code-btn {
    height: 52px;
    border-radius: 12px;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 500;
  }
}

/* 级联选择器定制 */
::v-deep .el-cascader.modern-input {
  width: 100%;
  .el-input__inner {
    padding-left: 15px; /* 覆盖 prefix-icon 的 padding */
    background-color: #f8fafc;
    border: 1px solid transparent;
    &:focus,
    &:hover {
      background-color: #f1f5f9;
      border-color: transparent;
      box-shadow: none;
    }
  }
}

/* 操作行：忘记密码/切换类型 */
.actions-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  margin-top: 8px; /* 避免遮挡 error 提示信息 */

  .el-button--text {
    color: #475569;
    font-size: 14px;
    padding: 0;
    &:hover {
      color: #2563eb;
    }
  }
}

/* 主提交按钮 */
.modern-submit-btn {
  width: 100%;
  height: 52px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  background: #3b82f6;
  border: none;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.25);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(59, 130, 246, 0.35);
    background: #2563eb;
  }

  &:active {
    transform: translateY(0);
  }

  .el-icon-right {
    font-size: 18px;
    font-weight: bold;
  }
}

/* ===== 扫码面板定制 ===== */
.qr-code-panel {
  text-align: center;
  padding-top: 20px;

  .qr-title {
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 30px;
  }

  .qr-code-box {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    height: 200px;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
    padding: 10px;
    margin-bottom: 20px;
    position: relative;
    border: 1px solid #e2e8f0;
  }

  .qr-expired {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    .expired-icon {
      font-size: 40px;
      color: #ef4444;
      margin-bottom: 12px;
    }

    .expired-text {
      font-size: 16px;
      color: #64748b;
      margin-bottom: 16px;
    }
  }

  .qr-tip {
    color: #64748b;
    font-size: 14px;
  }
}

/* ===== 协议行 ===== */
.login-footer-policy {
  margin-top: auto;
  text-align: center;
  font-size: 13px;
  color: #94a3b8;

  .policy-link {
    font-size: 13px;
    color: #2563eb;
    margin: 0 4px;
  }
}

/* ===== 页面底出版权声明 ===== */
.modern-page-footer {
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 10;

  .footer-item {
    a {
      color: #64748b;
      text-decoration: none;
      font-size: 13px;
      transition: color 0.3s;

      &:hover {
        color: #1e293b;
      }
    }
  }

  .flex-center a {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .national-emblem {
    width: 16px;
    height: 16px;
  }
}

/* 忘记密码弹窗样式覆盖 */
::v-deep .formInfoInput .el-input__inner {
  height: 40px;
  border-radius: 8px;
}

.tip {
  text-align: left;
  margin-bottom: 8px;
  line-height: 1.6;
  color: #475569;
}
</style>
